import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { createSelectors } from "../core/utils/create-selectors";

export interface GuestStore {
  isEditInfoModalOpen: boolean;
}

export interface GuestStoreActions {
  setIsEditInfoModalOpen: (isOpen: boolean) => void;
}

const initialState: GuestStore = {
  isEditInfoModalOpen: false
};

export const useGuestStoreBase = create(
  persist<GuestStore & GuestStoreActions>(
    (set) => ({
      ...initialState,
      setIsEditInfoModalOpen: (isOpen: boolean) => set(() => ({ isEditInfoModalOpen: isOpen }))
    }),
    {
      name: "guest-storage",
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

export const useGuestStore = createSelectors(useGuestStoreBase);
